import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "Parts/Title";

import Sidebar from "Parts/Sidebar";
import ListKelasItem from "Parts/ListKelasItem";
import Loading from "Parts/Loading";

import courses from "consts/api/courses";
import {
  statusCourses,
  fetchCourses,
  messageCourses,
} from "store/actions/courses";
import Centered from "Parts/Centered";

function EmptyState() {
  return (
    <section className="flex h-screen items-center">
      <div className="w-5/12 text-center py-12 mx-auto">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/mulai.jpg`}
          alt="Hore, berhasil join kelas baru."
        />
        <h1 className="text-3xl text-gray-900 mt-12">Masih kosong nih</h1>
        <p className="text-lg text-gray-600 mt-4 mb-8 mx-auto text-center">
          Waduh kelas masih kosong nih, jangan mau kalah sama yang lain, yuk
          mulai belajar.
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="bg-orange-500 hover:bg-orange-400 transition-all duration-200 focus:outline-none shadow-inner text-white px-6 py-3"
          href={`${process.env.REACT_APP_FRONTPAGE_URL}/kelas`}
        >
          Cari Kelas
        </a>
      </div>
    </section>
  );
}

export default function MyClass() {
  const dispatch = useDispatch();
  const KELAS = useSelector((state) => state.courses);

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(statusCourses("loading"));
    courses
      .mine()
      .then((res) => {
        dispatch(fetchCourses(res.data));
      })
      .catch((err) => {
        dispatch(
          messageCourses(
            err?.response?.data?.message ?? (
              <Centered>
                {err?.response?.data?.message ?? "Ada yang gak beres nih"}
              </Centered>
            )
          )
        );
      });
  }, [dispatch]);

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <>
        <main className="flex-1">
          <Title title="Kelasku"></Title>
          <div className="flex flex-col mt-8 px-16">
            <section className="grid grid-cols-8 gap-4">
              <div className="col-span-6">
                <h1 className="text-4xl text-gray-900 font-medium">KELASKU</h1>
                <p className="text-lg text-gray-600">
                  Lanjutkan proses belajarmu, kejar targetmu.
                </p>
              </div>
              <div className="col-span-2 justify-items-end my-auto">
                <div className="flex justify-end">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded relative flex items-center py-3 px-5 transition-all duration-200 bg-indigo-700 hover:text-white hover:bg-indigo-600  text-white focus:outline-none text-center"
                    href={`${process.env.REACT_APP_FRONTPAGE_URL}/kelas`}
                  >
                    Cari Kelas
                  </a>
                </div>
              </div>
            </section>
            {KELAS.status === "loading" && (
              <section className="-mt-32">
                <Loading></Loading>
              </section>
            )}
            {KELAS.status === "error" && KELAS.message}
            {KELAS.status === "ok" &&
              (KELAS.total > 0 ? (
                <section className="flex flex-col mt-8">
                  <div className="flex justify-start items-center -mx-4">
                    {Object.values(KELAS.data)?.map?.((item, index) => {
                      return (
                        <ListKelasItem
                          data={item.course}
                          key={index}
                        ></ListKelasItem>
                      );
                    })}
                  </div>
                </section>
              ) : (
                <EmptyState></EmptyState>
              ))}
          </div>
        </main>
      </>
    </div>
  );
}
